<template>
  <label class="c-input-checkbox">
    <input
      ref="checkboxInput"
      class="c-input-checkbox__input"
      type="checkbox"
      :disabled="disabled"
      :name="name"
      :checked="checked"
      :value="value"
      @change="handleChange"
    />
    <div
      class="c-input-checkbox__checked"
      tabindex="0"
      @keypress.enter="check"
    />
    <slot />
  </label>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  value?: []
  name?: string
  disabled?: boolean
  checked: boolean
}

withDefaults(defineProps<Props>(), {
  value: () => [],
  name: '',
  disabled: false,
})

const checkboxInput = ref(null)

const emit = defineEmits<{
  (e: 'update:checked', checked: boolean): void
}>()
const handleChange = ($event) => {
  emit('update:checked', ($event.target as HTMLInputElement).checked)
}

const check = () => {
  if (checkboxInput.value) (checkboxInput.value as HTMLInputElement).click()
}
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CCheckbox',
})
</script>
